export const branchTypes = {
  answerByQuestion: 'By Question',
  answerByTarget: 'By Target',
  formattedByTarget: 'Formatted',
};
